module.exports = __webpack_public_path__ + "img/maws.5071468e.svg";